'use client';

import React from 'react';
import Wishlist from '@/components/organisms/wishlist';
import Dashboard from '@/components/pages/dashboard';
import { DashboardLinks } from '@/components/pages/dashboard/constants';

const WishlistTastic = () => {
  return (
    <Dashboard href={DashboardLinks.savedProducts}>
      <Wishlist />
    </Dashboard>
  );
};

export default WishlistTastic;